<template>
  <WhiteIQOS
    required
    :enabled="enabled"
    :title="$t('auto_accept.title')"
    :subtitle="$t('auto_accept.subtitle')"
  >
    <BaseSelect v-model="waiter_id">
        <option :value="null" disabled>
            {{ $t('auto_accept.select_ph') }}
        </option>
        <option v-for="waiter in waiters" :value="waiter._id" :key="waiter._id">
            {{ waiter.name }}
        </option>
    </BaseSelect>

    <template #actions>
        <IQOSToggle v-model="enabled"/>
    </template>
  </WhiteIQOS>
</template>

<script>
export default {
  data() {
    return {
      enabled: false,
      waiter_id: null,

      busy: true
    };
  },
  watch: {
    waiter_id() {
        this.save();
    },
    enabled() {
        if (!this.enabled) this.waiter_id = null;
    }
  },
  methods: {
    save() {
        if (this.busy) return;

        this.$store.commit('patchCafeGeneralData', {
            auto_accept_waiter_id: this.waiter_id,
        });
        this.$store.dispatch('saveCafe');
    },
  },
  computed: {
    waiters() {
        return this.$store.state.waiters;
    }
  },
  mounted() {
    this.waiter_id = this.$store.state.cafe.auto_accept_waiter_id;
    this.enabled = !!this.waiter_id;
    this.busy = false;
  },
};
</script>

<style></style>
